import { connect } from 'react-redux';

import Simulator from './Simulator';

import { makeSelectAProject } from '../common/projects/selectors';
import { setToggleView } from '../common/settings/actions';
import { getProject, getTokenProject } from '../common/projects/actions';
import { getAnnualResults } from './TabBar/Results/selectors';


const mapStateToProps = (state, ownProps) => ({
    companyName: state.clientInfoUI.companyName,
    project: makeSelectAProject(state, ownProps),
    authToken: state.auth.authToken,
    annualResults: getAnnualResults(state),
    projectName: state.projectaddress.projectName,
    toggleView: state.settings.toggleView,
    projectToken: state.projectstatus.projectToken,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    email: state.contactUI.email,
    position: state.contactUI.position,
    projectStreet: state.projectaddress.projectStreet,
    projectStreet2: state.projectaddress.projectStreet2,
    projectCity: state.projectaddress.projectCity,
    projectZip: state.projectaddress.projectZip,
    projectState: state.projectaddress.projectState,
    setToggleView,
});

const mapDispatchToProps = dispatch => ({
    getProject: (projectId, authToken) => dispatch(getProject(projectId, authToken)),
    getTokenProject: token => dispatch(getTokenProject(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Simulator);



// WEBPACK FOOTER //
// ./src/containers/Simulator/index.js